import { render, staticRenderFns } from "./customExam.vue?vue&type=template&id=8fee6dd2&scoped=true&"
import script from "./customExam.vue?vue&type=script&lang=js&"
export * from "./customExam.vue?vue&type=script&lang=js&"
import style0 from "./customExam.vue?vue&type=style&index=0&id=8fee6dd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fee6dd2",
  null
  
)

export default component.exports